var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 44,
    viewBox: "0 0 90 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0881 1H1.12597L1 7.27087L32.041 7.39134L32.0811 31.5455L34.9724 33.7742L38.0644 33.0313L40.0924 35.6816L47.6819 38.0107L50.4728 36.9867L53.6251 40.3197L55.5727 38.7937L58.6045 40.7212L60.1907 39.6772L61.1946 42.0866L63.0016 39.2957L64.5878 40.8016L66.174 39.6169L69.1255 42.2673L73.3419 40.3398L74.5868 40.8819L75.9923 39.6972L79.3669 40.3411L81.2053 39.3851L88.4853 43.2825L89 21.0014L87.0881 7.47103V1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/OK.54c55b5787bbe3b9f299a04c614d4cdf.svg";
export { ForwardRef as ReactComponent };